/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Color_SecondaryInputs */



/**
* | output |
* | --- |
* | "Secondary" |
*
* @param {Presentation_Template_Color_SecondaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_color_secondary = /** @type {((inputs?: Presentation_Template_Color_SecondaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Color_SecondaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekundär")
	return /** @type {LocalizedString} */ ("Secondary")
});